import * as React from 'react'
import {
    Table,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    ExpandableRowContent,
    ThProps
} from '@patternfly/react-table';
import {
    useHistory,
    Link,
    useRouteMatch
} from "react-router-dom";

import { Namespace } from '@app/SecretManager/SecretsExplorer/model/repository'
import {
    ResourceItem,
    ResourceItemType,
    ResourceItemVariants
} from '@app/components/ResourceItem'

const NamespacesTable: React.FunctionComponent<{ namespaces: Namespace[]; clusterSelector?: React.ReactNode }> = ({ namespaces, clusterSelector }) => {

    const history = useHistory();
    const { path, url } = useRouteMatch<{ path: string, url: string }>();

    const column_names = {
        name: 'Name',
        applications: 'Applications',
        alerts: 'Alerts',
    }

    const table_body = function (namespaces: Namespace[]) {
        if (namespaces.length) {
            return namespaces.map((namespace, row_index) => (
                <Tr
                    key={namespace.name}
                >
                    <Td>
                        <ResourceItem type={ResourceItemType.Environment}>
                            <Link to={`${url}/${namespace.name}`}>{namespace.name}</Link>
                        </ResourceItem>
                    </Td>
                    <Td>{namespace.applications.length}</Td>
                </Tr>
            ))

        } else {
            return undefined
        }
    }

    return (
        <div className="secrets-page">
            <div className="secrets-page-header">
                <div className="secrets-page-header-row">
                    <h1 className="secrets-page-title">Secrets explorer</h1>
                    {clusterSelector}
                </div>
                <p className="secrets-page-subtitle">
                    Explore the usage of azure keyvault secrets across environments and applications.{' '}
                    <a className="secrets-link" target='_blank' rel='noopener noreferrer' href='https://teladochealth.atlassian.net/wiki/spaces/DEVOPS/pages/199887645/EOD+Dashboard+Secret+Manager#id-[EODDashboard]SecretManager-applications'>
                        User guide
                    </a>
                </p>
            </div>

            <div className="secrets-section">
                <h2 className="secrets-section-title">Environments</h2>
                <div className="secrets-table-wrapper">
                    <Table aria-label="namespaces table" variant='compact'>
                        <Thead>
                            <Tr>
                                <Th key={1}>{column_names.name}</Th>
                                <Th key={2}>{column_names.applications}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>{table_body(namespaces)}</Tbody>
                    </Table>
                </div>
            </div>
        </div>
    )
}

export { NamespacesTable };